export default __webpack_public_path__ + "static/media/2412252.7bebfed1.webp";